"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalStepperContainer = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledVerticalStepperContainer = styled_components_1.default.div `
  display: flex;
  flex: 1;
  overflow: hidden;
`;
const VerticalStepperContainer = props => {
    const { className, children } = props;
    return (react_1.default.createElement(StyledVerticalStepperContainer, { className: className }, children));
};
exports.VerticalStepperContainer = VerticalStepperContainer;
exports.default = exports.VerticalStepperContainer;
//# sourceMappingURL=VerticalStepperContainer.js.map